export interface OperatorIdentity {
  carrierUser?: {
    name?: string | null;
  } | null;
}

export const MISSING_OPERATOR_NAME = "Name required";

const EMAIL_SHAPED_NAME = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u;

export function operatorNameValidationError(value: string): string | null {
  const name = value.trim();
  if (!name) return "Name is required";
  if (name.length > 120) return "Name must be 120 characters or fewer";
  if (EMAIL_SHAPED_NAME.test(name)) {
    return "Enter the operator's name, not an email address";
  }
  return null;
}

export function validOperatorName(operator: OperatorIdentity): string | null {
  const name = operator.carrierUser?.name?.trim() ?? "";
  return operatorNameValidationError(name) === null ? name : null;
}

export function operatorDisplayName(operator: OperatorIdentity): string {
  return validOperatorName(operator) ?? MISSING_OPERATOR_NAME;
}

export function operatorInitials(operator: OperatorIdentity): string {
  const name = validOperatorName(operator);
  if (!name) return "?";

  const parts = name.split(/\s+/u);
  return `${parts[0]?.[0] ?? ""}${parts.length > 1 ? (parts.at(-1)?.[0] ?? "") : ""}`.toLocaleUpperCase();
}
